import React from 'react';
import Tag from '../ui/Tag';
import { useDispatch } from "react-redux";
import { updateBlog } from '../../features/blog/blogSlice';

function BlogDescription({ blog }) {
    //Variable
    const dispatch = useDispatch();
    const { id, title, tags, likes, isSaved, image, description } = blog || {};

    //Functions
    const handleSaveChange = (id) => {
        const updatedFields = { isSaved: !isSaved }
        dispatch(updateBlog({ id, updatedFields }))
    }

    const handleLikeChange = (id) => {
        const updatedFields = { likes: likes + 1 }
        dispatch(updateBlog({ id, updatedFields }))
    }
    return (
        <main className="post">
            <img src={image} alt="githum" className="w-full rounded-md" id="lws-megaThumb" />
            <div>
                <h1 className="mt-6 text-2xl post-title" id="lws-singleTitle">
                    {title}
                </h1>
                <div className="tags" id="lws-singleTags">
                    <Tag tags={tags} />
                </div>
                <div className="btn-group">
                    <button className="like-btn" id="lws-singleLinks" onClick={() => handleLikeChange(id)}>
                        <i className="fa-regular fa-thumbs-up"></i> {likes}
                    </button>
                    <button className={`${isSaved ? 'active' : ''} save-btn`} id="lws-singleSavedBtn" onClick={() => handleSaveChange(id)}>
                        <i className="fa-regular fa-bookmark"></i> {isSaved ? 'Saved' : 'Save'}
                    </button>
                </div>
                <div className="mt-6">
                    <p>
                        {description}
                    </p>
                </div>
            </div>
        </main>
    )
}

export default BlogDescription